module.exports = __webpack_public_path__ + "static/media/thumbnail.a18010c6.jpg";